import { Link } from "react-router-dom";

// trail: [{ name, path }] from Home; the last crumb is the current page.
// The matching BreadcrumbList structured data comes from lib/schema.js.
export const Breadcrumbs = ({ trail, className = "" }) => (
  <nav aria-label="Breadcrumb" className={className} data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
      {trail.map((crumb, i) => (
        <li key={crumb.path} className="flex items-center gap-2">
          {i > 0 && <span aria-hidden="true" className="text-foreground/30">/</span>}
          {i === trail.length - 1 ? (
            <span aria-current="page" className="text-foreground">{crumb.name}</span>
          ) : (
            <Link to={crumb.path} className="transition-colors hover:text-accent" data-testid={`breadcrumb-${i}`}>
              {crumb.name}
            </Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
